/**
 * Phone vs tablet, drawn where the platforms themselves draw it.
 *
 * Android's tablet resource qualifier is `sw600dp` — a shortest screen side of
 * at least 600 dp. Apple publishes no number, but every iPad reports ≥ 744 pt
 * on its short side (iPad mini) while the widest iPhone reports 440 pt, so the
 * same threshold separates them cleanly. `window.screen` is in CSS px (dp on
 * Android, pt on iOS) inside both WebViews; taking the shorter side makes the
 * answer orientation-proof — Android swaps screen.width/height on rotation,
 * iOS does not.
 *
 * Foldables come out the way Android itself reads them: folded (≈373 dp) they
 * are phones, unfolded (≈673 dp) they are tablets — and the verdict is LIVE,
 * not frozen at launch. A fold or unfold changes `window.screen` and fires
 * `resize`, which NativeOrientationLock listens to before re-applying its
 * policy; MainActivity re-applies its own rule in onConfigurationChanged (the
 * manifest's configChanges keep a fold from recreating the activity). iOS has
 * no foldables; its idiom check is a constant.
 *
 * The native layers apply the same rule on their own terms — iOS by
 * `UIDevice.userInterfaceIdiom`, Android by `R.bool.is_tablet` (sw600dp) — so
 * a device is a "phone" to the web bundle exactly when it is one to the OS.
 */
export const TABLET_MIN_SHORT_SIDE_CSS_PX = 600;

export const isPhoneFormFactor = (
  screen: Pick<Screen, 'width' | 'height'> = window.screen
): boolean => Math.min(screen.width, screen.height) < TABLET_MIN_SHORT_SIDE_CSS_PX;
